// The validation enum for each rows in the csv file
enum RowValidation {
  Valid = 0,
  Warning = 1,
  Error = 2,
}

export default RowValidation;



// WEBPACK FOOTER //
// ./src/scripts/models/RowValidation.ts